import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-dark-light" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <div className="bg-gradient-to-br from-secondary/40 to-dark border border-green-500/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-55">
          <div className="absolute top-0 right-0 -mt-10 -mr-10 text-green-500/10" data-id="element-56">
            <ShieldCheckIcon className="w-64 h-64" data-id="element-57" />
          </div>

          <div className="relative z-10" data-id="element-58">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-green-500/20 rounded-full mb-6" data-id="element-59">
              <ShieldCheckIcon className="w-10 h-10 text-green-500" data-id="element-60" />
            </div>

            <h2 className="text-3xl font-bold text-white mb-4" data-id="element-61">
              Garantía Total de 45 Días
            </h2>

            <p className="text-lg text-gray-300 max-w-xl mx-auto" data-id="element-62">
              Si por cualquier motivo sentís que este libro no cumplió tus
              expectativas simplemente pedís el reembolso y te devolvemos el
              dinero.
              <span className="block mt-2 font-bold text-white" data-id="element-63">
                Sin preguntas.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}